import { styled } from "@mui/material";



export const UpcomingSubscriptionText = styled("div")(() => ({
  fontFamily: "'DM Sans'",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "20px",
  display: "flex",
  alignItems: "center",
  color: "#565556",
  flex: 1,
})); 